module.exports = __webpack_public_path__ + "img/y-109.47446226.png";